'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

define(['app', 'module'], function (app, module) {

  var productQuickbuySimple = function productQuickbuySimple() {
    var component = {};

    var _config = {
      dataAttributes: {
        productIdSelector: 'data-product-id',
        siteIdSelector: 'data-site-id',
        fromWishlist: 'data-from-wishlist',
        defaultLocaleSelector: 'data-default-locale',
        subsiteCodeSelector: 'data-subsite-code',
        headerBasketSelector: 'header-basket',
        basketItemsSelector: 'basket-items',
        basketQuantityClass: 'header-menu-basket-counter',
        recommendationContext: 'data-context',
        recommendationParent: '[data-component=productRecommendations]'
      },
      subscribeChannels: {
        addedToBasket: 'productAddedToBasket/loadSuccess'
      },
      soldOutClass: 'productQuickbuySimple-soldOut'
    };

    var _init = function _init(element) {
      component.element = element;

      if (component.element) {
        component.productId = component.element.getAttribute(component.config.dataAttributes.productIdSelector);
        component.siteId = component.element.getAttribute(component.config.dataAttributes.siteIdSelector);
        component.defaultLocale = component.element.getAttribute(component.config.dataAttributes.defaultLocaleSelector);
        component.subsiteCode = component.element.getAttribute(component.config.dataAttributes.subsiteCodeSelector);
        component.fromWishlist = component.element.getAttribute(component.config.dataAttributes.fromWishlist);

        component.element.addEventListener('click', component.triggerAddToBasket);
      }

      component.basketHeaderClass = module.config().basketHeaderClass || component.config.dataAttributes.headerBasketSelector;
      component.basketHeaderID = module.config().basketHeaderID || false;
      component.basketItemsContainerClass = module.config().basketItemsContainerClass || component.config.dataAttributes.basketItemsSelector;

      component.context = component.getRecommendationContext();

      return component;
    };

    var _checkSubscribeMessages = function _checkSubscribeMessages(subscription, callback) {
      if (subscription.messages.length > 0) {
        var lastItem = subscription.messages.slice(-1)[0];
        callback(lastItem);
      }
    };

    var _triggerAddToBasket = function _triggerAddToBasket(event) {

      event.preventDefault();

      app.publish('addedToBasketModal/hideError', '', false);
      app.publish('productQuickbuy/hideError', '', false);
      app.publish('productQuickbuy/startLoading', '', false);
      app.publish('tracking/record', 'Product | AddToBasket', 'clicked', component.productId);

      var queryObj = {
        productId: component.productId,
        siteId: component.siteId,
        siteDefaultLocale: component.defaultLocale,
        siteSubsiteCode: component.subsiteCode,
        variationLength: 0,
        quantity: 1,
        fromWishlist: component.fromWishlist
      };

      if (component.context) {
        queryObj['rctxt'] = component.context;
      }

      component.postAddToBasket(queryObj);
    };

    var _postAddToBasket = function _postAddToBasket(queryObj) {
      if (queryObj && Object.keys(queryObj).length > 0) {
        app.ajax.get({
          url: '/basketinterface.json?' + querify(queryObj),
          success: component.addToBasketSuccess,
          error: component.addToBasketError
        });
      }
    };

    var _addToBasketError = function _addToBasketError() {
      app.publish('productQuickbuy/stopLoading', '', false);
      app.publish('productQuickbuy/showError', '', false);
      app.publish('addedToBasketModal/showError', '', false);
    };

    var _addToBasketSuccess = function _addToBasketSuccess(data) {
      var jsonData = JSON.parse(data);
      var modalData = component.getLastAddedItemData(jsonData.simpleBasket);
      app.publish('productQuickbuy/hideModal', '', false);
      app.publish('addedToBasketModal/productAdded', modalData, false);
      app.publish('globalBasketItemsCount/updateGlobalBasketItemsCount', modalData.basketTotalItems);
      app.publish('BasketItemAdded', jsonData);
    };

    var _getLastAddedItemData = function _getLastAddedItemData(simpleBasket) {
      var lastAddedItem = simpleBasket.lastAddedItem;

      var data = {
        productId: lastAddedItem.productId,
        productTitle: lastAddedItem.productTitle,
        productUrl: lastAddedItem.productURL,
        productQuantity: simpleBasket.lastAddedQuantity,
        productQuantityRequested: simpleBasket.lastAddedQuantityRequested,
        productPrice: lastAddedItem.price,
        basketTotalPrice: simpleBasket.totalprice,
        recommendations: simpleBasket.recommendations,
        basketTotalItems: simpleBasket.totalUnits,
        message: simpleBasket.message,
        lastAddedMaxPerOrder: lastAddedItem.maxPerOrder,
        loyaltySchemePoints: simpleBasket.loyaltySchemePoints
      };

      var imageURL = '';
      if (lastAddedItem.productImages && lastAddedItem.productImages.largeproduct) {
        imageURL = lastAddedItem.productImages.largeproduct;
      }
      data.productImageUrl = imageURL;
      return data;
    };

    var _getRecommendationContext = function _getRecommendationContext() {
      // polyfill for IE8+
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }

      if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
          var el = this;
          if (!document.documentElement.contains(el)) return null;
          do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
          } while (el !== null && el.nodeType === 1);
          return null;
        };
      }

      var recommendationParent = component.element.closest(component.config.dataAttributes.recommendationParent);
      return recommendationParent ? recommendationParent.getAttribute(component.config.dataAttributes.recommendationContext) : '';
    };

    component.init = _init;
    component.config = _config;
    component.checkSubscribeMessages = _checkSubscribeMessages;
    component.triggerAddToBasket = _triggerAddToBasket;
    component.postAddToBasket = _postAddToBasket;
    component.addToBasketSuccess = _addToBasketSuccess;
    component.addToBasketError = _addToBasketError;
    component.getLastAddedItemData = _getLastAddedItemData;
    component.getRecommendationContext = _getRecommendationContext;

    return component;
  };

  var querify = function querify(obj) {
    return Object.entries(obj).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return key + '=' + value;
    }).join('&');
  };

  return productQuickbuySimple;
});
//# sourceMappingURL=productQuickbuySimple.js.map
